/** Official web SPA — `public/` 정적 에셋 경로 (repo-root `public/` 를 vite `publicDir` 로 공유) */

export const BRAND = {
  /** 헤더용 TYCOONEX 워드마크 (336×82, 2× @168px) */
  tycoonWordmarkHeader: "/images/brand/tycoonex-wordmark-header.webp",
  /** 추천 팩 카드팩 이미지 */
  cardPack: "/images/pioneer/card-pack.webp",
} as const;
